import React from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import MetaInfo from '../BeyondMeat/MetaInfo/MetaInfo';
import imgHero from './i/beyond_meat_hero.jpg';
import imgHeroFr from './i/beyond_meat_hero_fr.jpg';
import imgHeroMobile from './i/mobile/beyond_meat_hero.jpg';
import imgHeroMobileFr from './i/mobile/beyond_meat_hero_fr.jpg';
import Icon from '../../../../components/Icon/Icon';
import arrow from '../../../../assets/images/hero-arrow.png';
import BeyondMeatSlider from '../../../../components/BeyondMeatSlider/BeyondMeatSlider';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';


const BeyondMeat = (props) => {

    return (
        <>
            <MetaInfo {...props} />
            <div className="blockwrap our-food beyond-meat">
                <div className="intro-block">
                    {props.isDesktop ? 
                        props.lang !== 'fr' ? <img className="intro-bg-img" src={imgHero} alt="beyond meat" /> : <img className="intro-bg-img" src={imgHeroFr} alt="beyond meat" />
                        : 
                        props.lang !== 'fr' ? <img className="intro-bg-img" src={imgHeroMobile} alt="beyond meat" /> : <img className="intro-bg-img" src={imgHeroMobileFr} alt="beyond meat" />
                    }
                </div>

                <div className="copy-block">
                    <h1>Beyond Meat<sup className="sup-dagger">†</sup></h1>
                    
                    {props.lang === 'en' && <p>Change is good. That's why we teamed up with Beyond Meat to become the first national burger restaurant in Canada to serve their delicious plant-based protein. Our Beyond Meat Burger patty is plant-based, juicy, satisfying and everything a burger should be.</p>}
                    {props.lang === 'fr' && <p>Changer c'est bon (vraiment bon). C'est pourquoi nous avons fait équipe avec Beyond Meat pour devenir la première chaîne nationale de burgers à servir leurs délicieuses protéines de plantes. Notre boulette à burger Beyond Meat est faite à base de plantes, elle est juteuse, savoureuse et a tout pour vous plaire.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>

            <div className="where-block">
                
                {props.lang !== 'fr' ?
                    <>
                        <h2>Check out our&nbsp;
                            <span>Ingredients</span>
                        </h2>
                    </>
                    :
                    <>
                        <h2>Découvrez les&nbsp;  
                            <span>ingrédients</span>
                        </h2>
                    </>
                }
            </div>
            <BeyondMeatSlider {...props} />

            <div className="blockwrap our-food faq-block beyondmeat">
            
            <Link  className="find-aw"  to={`/${props.lang}/faq/beyond-meat`}>
                {props.lang !== 'fr' ? 
                    <><span>beyond meat</span> FAQ<Icon type=" gt-inverted" /></>
                    :
                    <><span>FAQ sur</span> beyond meat<Icon type=" gt-inverted" /></>
                }
            </Link>

        </div>

        <IngredientsSlider currentPage="beyond-meat" {...props} />
        <MobileOrderBanner {...props} />

        </>

    )
}
export default BeyondMeat;